/* eslint-disable @typescript-eslint/no-shadow,@typescript-eslint/no-unused-vars */

import { EVENTS } from '../../../../app/constants/events';
import { getDataForSchemaImporter } from '../../../../app/package-designer/helpers/schema.helpers';
import { COMPONENT_TYPE } from '../../../../app/constants/component_type';

xplenty.directive('salesforceSourceEditor', [
  '$timeout',
  'ConnectionItemsResource',
  function ($timeout, ConnectionItemsResource) {
    return {
      restrict: 'E',

      // eslint-disable-next-line global-require
      template: require('./salesforce-source-editor.html'),

      replace: true,

      scope: false,

      controller: [
        '$scope',
        'connectionsService',
        '$stateParams',
        '$rootScope',

        '$translate',
        function ($scope, connectionsService, $stateParams, $rootScope, $translate) {
          $scope.sourceActions = [
            { text: 'Bulk query', value: 'query' },
            { text: 'Bulk query all', value: 'queryAll' },
          ];

          $scope.onSourceActionChange = (sourceAction) => {
            $scope.component.source_action = sourceAction;
          };

          $scope.$on(EVENTS.DATA_PREVIEW_REFRESH, function (event, fields) {
            const schemaRequestData = getDataForSchemaImporter(
              { ...$scope.component, schema: { fields } },
              COMPONENT_TYPE.SALESFORCE_SOURCE_COMPONENT,
              $stateParams.account_id,
            );

            ConnectionItemsResource.schema(
              $scope.component.connection.type,
              $scope.component.connection.id,
              schemaRequestData,
            ).subscribe(
              function (data) {
                $rootScope.$broadcast(EVENTS.SCHEMA_IMPORTER_LOADED, data);
              },
              function ({ error }) {
                if (error) {
                  $rootScope.$broadcast(EVENTS.DATA_PREVIEW_ERROR, error.error_message);
                }
              },
            );
          });

          $scope.bodyDataOptions = {
            lineWrapping: true,
            lineNumbers: true,
            mode: 'text/x-sql',
            placeholder: $translate.instant('salesforce-source-editor.form.placeholders.where_clause'),
          };

          $scope.queryEditorOptions = {
            placeholder: 'SELECT field FROM object',
          };

          $scope.$watch('component.access_mode', function (accessMode) {
            if (accessMode === 'object') {
              $scope.component.disableSchemaLoad = true;
              delete $scope.component.file_type;
            } else {
              $scope.component.disableSchemaLoad = false;
              $scope.component.file_type = 'service_type';
            }
          });

          $scope.$watch('component.is_chunk_size_enabled', function (isChunkSizeEnabled) {
            if (isChunkSizeEnabled && !$scope.component.chunk_size) {
              $scope.component.chunk_size = 100000;
            }
          });
        },
      ],
    };
  },
]);
